export const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email)

export const isValidName = (name: string) => /^[^0-9]+$/g.test(name) && name.trim().length > 0
